// extracted by mini-css-extract-plugin
export default {"input-checkbox":"SortOptions_input-checkbox__teolt","input-label":"SortOptions_input-label__W3CiC","select-option":"SortOptions_select-option__1OiH6"};